// @flow

import {ImageSrc, Href} from 'docs/markdoc/attribute-types';
import type {MarkdocTagRegistration} from 'docs/markdoc';

export const VideoHeroSection: MarkdocTagRegistration = {
  tag: 'video-hero-section',
  component: 'VideoHeroSection',
  attributes: {
    videoTitle: {
      type: String,
      required: true,
      description: 'video title of hero section',
      localizable: true,
    },
    linkHref: {
      type: Href,
      required: true,
      description: 'Href for the link that is shown below the description',
    },
    imageSrc: {
      type: ImageSrc,
      required: true,
      description: 'Path to the image file that is shown',
    },
    playlistName: {
      type: String,
      required: true,
      description: 'name of the playlist of featured video',
      localizable: true,
    },
  },
};
